(() => {
  'use strict';
  let busy = false, converting = false, quantityTimer;
  const root = () => document.querySelector('[data-wv-cart]');
  const sectionIds = () => [...document.querySelectorAll('[data-cart-section]')].map(e=>e.dataset.cartSection);
  function message(text, error = false) {
    const target = document.querySelector('[data-cart-feedback]');
    if (target) { target.textContent = text; target.dataset.error = String(error); }
  }
  function lock(value) {
    busy = value;
    root()?.setAttribute('aria-busy',String(value));
    document.querySelectorAll('[data-cart-action], [data-cart-quantity], [data-cart-checkout], .wv-cart-add-form button').forEach(e=>{e.disabled=value;});
    if (!value) document.querySelectorAll('[data-cart-action="decrease"]').forEach(e=>{e.disabled=Number(e.closest('[data-cart-line]').querySelector('[data-cart-quantity]').value)<=1;});
  }
  function replaceSections(data, focus) {
    const position = window.scrollY;
    const sections = data.sections || {};
    if (!sectionIds().every(id=>sections[id])) { window.location.reload(); return false; }
    for (const [id, html] of Object.entries(sections)) {
      if (!html) { window.location.reload(); return false; }
      const old = document.getElementById(`shopify-section-${id}`);
      const fresh = new DOMParser().parseFromString(html,'text/html').getElementById(`shopify-section-${id}`);
      if (old && fresh) {
        const currentWidget = old.querySelector('[data-cart-goalify]');
        const nextWidget = fresh.querySelector('[data-cart-goalify]');
        if (currentWidget && nextWidget) {
          currentWidget.hidden = nextWidget.hidden;
          nextWidget.replaceWith(currentWidget);
        }
        old.replaceWith(fresh);
      }
    }
    const count = root()?.dataset.cartCount;
    document.querySelectorAll('.wv-header-bag').forEach(link=>{
      const badge = link.querySelector('[data-wv-cart-count]');
      if (badge) badge.textContent=count;
      link.setAttribute('aria-label',`${root()?.dataset.bagLabel || 'Bag'}: ${count}`);
    });
    document.body.classList.toggle('wv-cart-page',Number(count)>0);
    document.dispatchEvent(new CustomEvent('wv:cart:rendered'));
    const matched = focus && [...document.querySelectorAll('[data-cart-action]')].find(e=>e.dataset.lineKey===focus.key && e.dataset.cartAction===focus.action);
    matched?.focus({preventScroll:true});
    window.scrollTo({top:position,behavior:'instant'});
    return true;
  }
  async function request(url, body) {
    const response = await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...body,sections:sectionIds(),sections_url:window.location.pathname+window.location.search})});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || root()?.dataset.errorMessage);
    return data;
  }
  async function refreshCart() {
    const url=new URL(window.location.href);
    url.searchParams.set('sections',sectionIds().join(','));
    const [cartResponse,sectionResponse]=await Promise.all([fetch(root().dataset.cartUrl,{headers:{Accept:'application/json'}}),fetch(url.toString(),{headers:{Accept:'application/json'}})]);
    if(!cartResponse.ok || !sectionResponse.ok) throw new Error(root().dataset.errorMessage);
    const [cart,sections]=await Promise.all([cartResponse.json(),sectionResponse.json()]);
    return {...cart,sections};
  }
  function config() {
    const element = document.querySelector('[data-cart-bundle-config]');
    return element ? JSON.parse(element.textContent) : null;
  }
  async function applyBundle(cart) {
    if (converting || !window.WellvaneCartLogic) return cart;
    const plan = window.WellvaneCartLogic.planRitual(cart,config());
    if (!plan) return cart;
    converting = true;
    try {
      const result = await request(root().dataset.updateUrl,{updates:plan.updates});
      // Shopify calculates and renders the actual native bundle price.
      return result;
    } finally { converting = false; }
  }
  async function change(key, quantity, focus) {
    if (busy) return;
    const initial = root();
    const field = [...initial.querySelectorAll('[data-cart-quantity]')].find(e=>e.dataset.lineKey===key);
    const oldQuantity = field?.dataset.originalQuantity;
    lock(true); message(initial.dataset.updating);
    try {
      let cart = await request(initial.dataset.changeUrl,{id:key,quantity});
      cart = await applyBundle(cart);
      replaceSections(cart,focus);
      message(root()?.dataset.updated);
    } catch(error) {
      try {replaceSections(await refreshCart());} catch {if (field && field.isConnected && oldQuantity != null) field.value=oldQuantity;}
      message(error.message || initial.dataset.errorMessage,true);
    } finally { lock(false); }
  }
  document.addEventListener('click',event=>{
    const action = event.target.closest('[data-cart-action]');
    if (!action) return;
    event.preventDefault();
    clearTimeout(quantityTimer);
    if (busy) return;
    const field = [...document.querySelectorAll('[data-cart-quantity]')].find(e=>e.dataset.lineKey===action.dataset.lineKey);
    const quantity = action.dataset.cartAction==='remove' ? 0 : Math.max(1,Math.min(99,Number(field.value)+(action.dataset.cartAction==='increase'?1:-1)));
    change(action.dataset.lineKey,quantity,{key:action.dataset.lineKey,action:action.dataset.cartAction});
  });
  function commitQuantity(field, reportInvalid) {
    if (!field?.isConnected || busy) return;
    const value=Number(field.value);
    if (!Number.isInteger(value) || value<1 || value>99) {
      if (reportInvalid) {field.value=field.dataset.originalQuantity;message(root().dataset.quantityError,true);}
      return;
    }
    if (value!==Number(field.dataset.originalQuantity)) change(field.dataset.lineKey,value);
  }
  document.addEventListener('input',event=>{
    const field=event.target.closest('[data-cart-quantity]');
    if (!field || busy) return;
    clearTimeout(quantityTimer);
    quantityTimer=setTimeout(()=>commitQuantity(field,false),500);
  });
  document.addEventListener('change',event=>{
    const field=event.target.closest('[data-cart-quantity]');
    if (!field) return;
    clearTimeout(quantityTimer);
    commitQuantity(field,true);
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if (!form.matches('.wv-cart-add-form')) return;
    event.preventDefault();
    if (busy) return;
    const initial=root(); lock(true); message(initial.dataset.updating);
    try {
      const added=await request(form.action+'.js',{items:[{id:Number(form.querySelector('[name=id]').value),quantity:1}]});
      const response=await fetch(initial.dataset.cartUrl,{headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error(initial.dataset.errorMessage);
      const cart=await response.json();
      const finalCart=await applyBundle(cart);
      replaceSections(finalCart===cart ? added : finalCart);
      message(root()?.dataset.updated);
    } catch(error) {try{replaceSections(await refreshCart());}catch{}message(error.message||initial.dataset.errorMessage,true);}
    finally {lock(false);}
  });
  async function initialize() {
    const initial=root();
    if(!initial) return;
    document.body.classList.toggle('wv-cart-page',Number(initial.dataset.cartCount)>0);
    if(!config()?.enabled || busy) return;
    try {
      const response=await fetch(initial.dataset.cartUrl,{headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart=await response.json();
      if(!window.WellvaneCartLogic?.planRitual(cart,config())) return;
      lock(true); message(initial.dataset.updating);
      const finalCart=await applyBundle(cart);
      replaceSections(finalCart); message(root()?.dataset.updated);
    } catch(error) {try{replaceSections(await refreshCart());}catch{}message(error.message||initial.dataset.errorMessage,true);}
    finally {lock(false);}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
